export { EDITOR_TYPE, AutocompleteEditor } from "./autocompleteEditor.mjs";


//////////////////
// WEBPACK FOOTER
// ./~/handsontable/editors/autocompleteEditor/index.mjs
// module id = 310
// module chunks = 1